import _asyncToGenerator from "/codebuild/output/src20/src/s3/01/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _wrapAsyncGenerator from "/codebuild/output/src20/src/s3/01/node_modules/@babel/runtime/helpers/esm/wrapAsyncGenerator.js";
import _awaitAsyncGenerator from "/codebuild/output/src20/src/s3/01/node_modules/@babel/runtime/helpers/esm/awaitAsyncGenerator.js";
import _asyncGeneratorDelegate from "/codebuild/output/src20/src/s3/01/node_modules/@babel/runtime/helpers/esm/asyncGeneratorDelegate.js";
import "core-js/modules/es.typed-array.set.js";
import "core-js/modules/es.typed-array.sort.js";
import _regeneratorRuntime from "/codebuild/output/src20/src/s3/01/node_modules/@babel/runtime/regenerator/index.js";
function _asyncIterator(r) { var n, t, o, e = 2; for ("undefined" != typeof Symbol && (t = Symbol.asyncIterator, o = Symbol.iterator); e--;) { if (t && null != (n = r[t])) return n.call(r); if (o && null != (n = r[o])) return new AsyncFromSyncIterator(n.call(r)); t = "@@asyncIterator", o = "@@iterator"; } throw new TypeError("Object is not async iterable"); }
function AsyncFromSyncIterator(r) { function AsyncFromSyncIteratorContinuation(r) { if (Object(r) !== r) return Promise.reject(new TypeError(r + " is not an object.")); var n = r.done; return Promise.resolve(r.value).then(function (r) { return { value: r, done: n }; }); } return AsyncFromSyncIterator = function AsyncFromSyncIterator(r) { this.s = r, this.n = r.next; }, AsyncFromSyncIterator.prototype = { s: null, n: null, next: function next() { return AsyncFromSyncIteratorContinuation(this.n.apply(this.s, arguments)); }, "return": function _return(r) { var n = this.s["return"]; return void 0 === n ? Promise.resolve({ value: r, done: !0 }) : AsyncFromSyncIteratorContinuation(n.apply(this.s, arguments)); }, "throw": function _throw(r) { var n = this.s["return"]; return void 0 === n ? Promise.reject(r) : AsyncFromSyncIteratorContinuation(n.apply(this.s, arguments)); } }, new AsyncFromSyncIterator(r); }
export var streamChunk = /*#__PURE__*/_regeneratorRuntime.mark(function streamChunk(chunk, chunkSize) {
  var len, pos, end;
  return _regeneratorRuntime.wrap(function streamChunk$(_context) {
    while (1) switch (_context.prev = _context.next) {
      case 0:
        len = chunk.byteLength;
        if (!(!chunkSize || len < chunkSize)) {
          _context.next = 5;
          break;
        }
        _context.next = 4;
        return chunk;
      case 4:
        return _context.abrupt("return");
      case 5:
        pos = 0;
      case 6:
        if (!(pos < len)) {
          _context.next = 13;
          break;
        }
        end = pos + chunkSize;
        _context.next = 10;
        return chunk.slice(pos, end);
      case 10:
        pos = end;
        _context.next = 6;
        break;
      case 13:
      case "end":
        return _context.stop();
    }
  }, streamChunk);
});
export var readBytes = /*#__PURE__*/function () {
  var _ref = _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(iterable, chunkSize) {
    var _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, chunk;
    return _regeneratorRuntime.wrap(function _callee$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _iteratorAbruptCompletion = false;
          _didIteratorError = false;
          _context2.prev = 2;
          _iterator = _asyncIterator(readStream(iterable));
        case 4:
          _context2.next = 6;
          return _awaitAsyncGenerator(_iterator.next());
        case 6:
          if (!(_iteratorAbruptCompletion = !(_step = _context2.sent).done)) {
            _context2.next = 12;
            break;
          }
          chunk = _step.value;
          return _context2.delegateYield(_asyncGeneratorDelegate(_asyncIterator(streamChunk(chunk, chunkSize)), _awaitAsyncGenerator), "t0", 9);
        case 9:
          _iteratorAbruptCompletion = false;
          _context2.next = 4;
          break;
        case 12:
          _context2.next = 18;
          break;
        case 14:
          _context2.prev = 14;
          _context2.t1 = _context2["catch"](2);
          _didIteratorError = true;
          _iteratorError = _context2.t1;
        case 18:
          _context2.prev = 18;
          _context2.prev = 19;
          if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) {
            _context2.next = 23;
            break;
          }
          _context2.next = 23;
          return _awaitAsyncGenerator(_iterator["return"]());
        case 23:
          _context2.prev = 23;
          if (!_didIteratorError) {
            _context2.next = 26;
            break;
          }
          throw _iteratorError;
        case 26:
          return _context2.finish(23);
        case 27:
          return _context2.finish(18);
        case 28:
        case "end":
          return _context2.stop();
      }
    }, _callee, null, [[2, 14, 18, 28], [19,, 23, 27]]);
  }));
  return function readBytes(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();
var readStream = /*#__PURE__*/function () {
  var _ref2 = _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(stream) {
    var reader, _yield$_awaitAsyncGen, done, value;
    return _regeneratorRuntime.wrap(function _callee2$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          if (!stream[Symbol.asyncIterator]) {
            _context3.next = 3;
            break;
          }
          return _context3.delegateYield(_asyncGeneratorDelegate(_asyncIterator(stream), _awaitAsyncGenerator), "t0", 2);
        case 2:
          return _context3.abrupt("return");
        case 3:
          reader = stream.getReader();
          _context3.prev = 4;
        case 5:
          _context3.next = 7;
          return _awaitAsyncGenerator(reader.read());
        case 7:
          _yield$_awaitAsyncGen = _context3.sent;
          done = _yield$_awaitAsyncGen.done;
          value = _yield$_awaitAsyncGen.value;
          if (!done) {
            _context3.next = 12;
            break;
          }
          return _context3.abrupt("break", 16);
        case 12:
          _context3.next = 14;
          return value;
        case 14:
          _context3.next = 5;
          break;
        case 16:
          _context3.prev = 16;
          _context3.next = 19;
          return _awaitAsyncGenerator(reader.cancel());
        case 19:
          return _context3.finish(16);
        case 20:
        case "end":
          return _context3.stop();
      }
    }, _callee2, null, [[4,, 16, 20]]);
  }));
  return function readStream(_x3) {
    return _ref2.apply(this, arguments);
  };
}();
export var trackStream = function trackStream(stream, chunkSize, onProgress, onFinish) {
  var iterator = readBytes(stream, chunkSize);
  var bytes = 0;
  var done;
  var _onFinish = function _onFinish(e) {
    if (!done) {
      done = true;
      onFinish && onFinish(e);
    }
  };
  return new ReadableStream({
    pull: function pull(controller) {
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var _yield$iterator$next, _done, value, len, loadedBytes;
        return _regeneratorRuntime.wrap(function _callee3$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.prev = 0;
              _context4.next = 3;
              return iterator.next();
            case 3:
              _yield$iterator$next = _context4.sent;
              _done = _yield$iterator$next.done;
              value = _yield$iterator$next.value;
              if (!_done) {
                _context4.next = 10;
                break;
              }
              _onFinish();
              controller.close();
              return _context4.abrupt("return");
            case 10:
              len = value.byteLength;
              if (onProgress) {
                loadedBytes = bytes += len;
                onProgress(loadedBytes);
              }
              controller.enqueue(new Uint8Array(value));
              _context4.next = 19;
              break;
            case 15:
              _context4.prev = 15;
              _context4.t0 = _context4["catch"](0);
              _onFinish(_context4.t0);
              throw _context4.t0;
            case 19:
            case "end":
              return _context4.stop();
          }
        }, _callee3, null, [[0, 15]]);
      }))();
    },
    cancel: function cancel(reason) {
      _onFinish(reason);
      return iterator["return"]();
    }
  }, {
    highWaterMark: 2
  });
};